import { useState } from 'react';
import { faqItems } from '@/mocks/home';

export default function Faq() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">常见问题</h2>
          <p className="text-sm md:text-base text-foreground-500">关于51漫画的下载与使用，您想了解的都在这</p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-100 rounded-xl overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === idx ? -1 : idx)}
                className="w-full flex items-center justify-between gap-4 p-4 md:p-5 text-left cursor-pointer"
              >
                <h3 className="text-sm md:text-base font-semibold text-foreground-950 pr-4">
                  {item.q}
                </h3>
                <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 rounded-full transition-colors ${
                  openIndex === idx ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-500'
                }`}>
                  <i className={`text-sm transition-transform duration-300 ${openIndex === idx ? 'ri-subtract-line' : 'ri-add-line'}`}></i>
                </div>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openIndex === idx ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-4 md:px-5 pb-4 md:pb-5">
                  <p className="text-sm text-foreground-600 leading-relaxed">{item.a}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}